interface CommunityNavigationUser {
  isAnonymous: boolean;
}

export function shouldShowCommunityNavigation(
  user: CommunityNavigationUser | null | undefined,
): boolean {
  return user?.isAnonymous === false;
}
